import React, { FC } from "react";

import { Button } from "@/components/Button";
import { Icon } from "@/components/Icon";
import { Flex } from "@/eworkitComponents";

import "./_mobile-menu-icon.scss";

interface IMobileMenuIconProps {
  isOpen?: boolean;
}

export const MobileMenuIcon: FC<IMobileMenuIconProps> = ({ isOpen }) => {
  const baseClass = "mobile-menu-icon";

  return (
    <Flex className={baseClass} padding={["md"]}>
      <Button variant="clean" size="xl">
        <Icon icon={isOpen ? "close" : "menu"} className={`${baseClass}__icon`} size="xl" color="grey1" />
      </Button>
    </Flex>
  );
};
